import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { handleDeNorm, normalizePhone, deNormalizePhone, handleNorm } from '../../utils/functions/tools/normalizePhone';
import { Breadcrumb, Button, BreadcrumbItem, Tile, Select, SelectItem, NotificationActionButton, InlineNotification, Link, OverflowMenuItem, OverflowMenu, TextInput, Form } from 'carbon-components-react'
import { sleep } from '../../utils/functions/tools/sleep';
import Toast from '../../components/Notification/Toast'
const { REACT_APP_DEV_API_URL, REACT_APP_PROD_API_URL, NODE_ENV } = process.env;
const API_URL =
    NODE_ENV === 'production' ? process.env.REACT_APP_PROD_API_URL : process.env.REACT_APP_DEV_API_URL;


const AddClients = ({ match }) => {

    // Other Variables
    let [authTokens, setAuthTokens] = useState(() => localStorage.getItem('authTokens') ? JSON.parse(localStorage.getItem('authTokens')) : null)
    let [currencies, setCurrencies] = useState(null)
    let [currencyCode, setCurrencyCode] = useState(null)
    let [countries, setCountries] = useState(null)

    const [list, setList] = useState([]);
    let toastProperties = null;

    const [error, setError] = useState(false);
    const history = useHistory()
    const [phoneInput, setPhoneInput] = useState("");

    // General
    const [curDate, setCurDate] = useState(null)

    useEffect(() => {
        getCurrencies()
        getCountries()
        document.title = "Add Client | WillowBMS"
        let date = new Date().getFullYear() + '-' + ('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2)
        setCurDate(date)
    }, [])

    let getCurrencies = async () => {
        let response = await fetch(`${API_URL}/system/financial/currencies/`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCurrencies(data)
    }

    let getCountries = async () => {
        let response = await fetch(`${API_URL}/system/referencedata/geographical/countries/`, {
            method: "GET",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            }
        })
        let data = await response.json()
        setCountries(data)
    }

    const showToast = (type, title, description) => {
        const id = Math.floor((Math.random() * 100) + 1);
        const time = new Date().toLocaleString();

        switch (type) {
            case 'success':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'success',
                    time: time
                }
                break;
            case 'error':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'error',
                    time: time
                }
                break;
            case 'info':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'info',
                    time: time
                }
                break;
            case 'warning':
                toastProperties = {
                    id,
                    title: title,
                    description: description,
                    kind: 'warning',
                    time: time
                }
                break;
            default:
                setList([]);
        }
        setList([...list, toastProperties]);
    }

    let createClient = async (values) => {
        values.preventDefault()
        
        let response = await fetch(`${API_URL}/client/create/`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + authTokens?.access
            },
            body: JSON.stringify({
                'company': values.target.company.value,
                'phoneNumber': values.target.phoneNumber.value,
                'email': values.target.email.value,
                'startDate': curDate,
                'address1': values.target.address1.value,
                'address2': values.target.address2.value,
                'city': values.target.city.value,
                'province': values.target.province.value,
                'country': values.target.country.value,
                'postalcode': values.target.postalcode.value,
                'addressType':1,
                'currency': values.target.currency.value,
                'language': values.target.language.value,
                'type': values.target.accountType.value,
            })
        })
        let data = await response.json()
        let newClient = await JSON.parse(data)["newClient"]
        if (response.status === 200) {
            showToast("success", "Success", "Client has been added. Please wait for redirect.")
            setError(false)
            await sleep(2000)
            history.push(`/client/dashboard/${newClient}`)
        } else {
            setError(true)
        }
    }

    return (
        <div className="bms-page">
            <>
            <Toast toastList={list} />
                <div className="mb-2">
                    <Breadcrumb>
                        <BreadcrumbItem href="/clients">Clients</BreadcrumbItem>
                        <span>Add Client</span>
                    </Breadcrumb>
                </div>
                <div>
                    <Form onSubmit={(values) => createClient(values)} className="d-flex flex-w">
                        <Tile><h2 className="d-flex">Add Client</h2></Tile>
                        <Tile light={true} className="w-full d-flex flex-w" style={{ minHeight: 0 }}>
                            <div className="col-12 m-005">
                            {error && <InlineNotification className="mb-1" kind="error" hideCloseButton={true} title="Error: Unable to add client" subtitle="Please try again or contact your administrator." actions={<NotificationActionButton onClick={(() => setError(false))}>Dismiss</NotificationActionButton>} />}
                                <strong className="d-flex">Profile Information</strong>
                                <p className="text-sm">Enter in the identifiable information for the client.</p>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    required
                                    data-modal-primary-focus
                                    id="company"
                                    name="company"
                                    labelText="Company Name"
                                    placeholder="Enter company name"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    data-modal-primary-focus
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    labelText="Phone Number (optional)"
                                    placeholder="Enter phone number"
                                    onChange={((e) => setPhoneInput(normalizePhone(e.target.value)))}
                                    value={phoneInput}
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    data-modal-primary-focus
                                    id="email"
                                    name="email"
                                    labelText="Email Address"
                                    placeholder="Enter email address"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 m-005">
                                <strong className="d-flex">Address Information</strong>
                                <p className="text-sm">Enter in the client's business address.</p>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    required
                                    data-modal-primary-focus
                                    id="address1"
                                    name="address1"
                                    invalidText="Address 1 is required"
                                    labelText="Address 1"
                                    placeholder="Enter address 1"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    data-modal-primary-focus
                                    id="address2"
                                    name="address2"
                                    labelText="Address 2 (optional)"
                                    placeholder="Enter address 2"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    required
                                    data-modal-primary-focus
                                    id="city"
                                    name="city"
                                    labelText="City"
                                    placeholder="Enter city"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    required
                                    data-modal-primary-focus
                                    id="province"
                                    name="province"
                                    labelText="Province/State"
                                    placeholder="Enter province/state"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <Select id="country" name="country" defaultValue="CA" labelText="Country">
                                    {countries?.map((country, index) => (
                                        <SelectItem selected={country.countrycode === "CA" ? "selected" : ""} key={index} value={country.countrycode} text={country.country} />
                                    ))}
                                </Select>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <TextInput
                                    data-modal-primary-focus
                                    id="postalcode"
                                    name="postalcode"
                                    labelText="Postal Code (optional)"
                                    placeholder="Enter postal code"
                                    style={{ marginBottom: '1rem' }}
                                />
                            </div>
                            <div className="col-12 m-005">
                                <strong className="d-flex">Client Settings</strong>
                                <p className="text-sm">Choose the client's system settings. These can be changed later on as well.</p>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <Select id="accountType" name="accountType" defaultValue="Organization" labelText="Account Type">
                                    <SelectItem value="Organization" text="Organization" />
                                    <SelectItem value="Private" text="Private" />
                                    <SelectItem value="Non-Profit" text="Non-Profit" />
                                </Select>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <Select id="currency" name="currency" defaultValue="CAD" labelText="Currency">
                                    {currencies?.map((currency, index) => (
                                        <SelectItem selected={currency.currencycode === "CAD" ? "selected" : ""} key={index} value={currency.id} text={currency.currencycode} />
                                    ))}
                                </Select>
                            </div>
                            <div className="col-12 col-md-6 m-005">
                                <Select id="language" name="language" defaultValue="English" labelText="Language">
                                    <SelectItem value="English" text="English" />
                                    <SelectItem value="French" text="French" />
                                </Select>
                            </div>
                            <div className="col-12 m-005 mt-1">
                                <Button
                                    kind="primary"
                                    tabIndex={0}
                                    type="submit"
                                    className="mr-05"
                                >
                                    Add Client
                                </Button>
                                <Button
                                    kind="secondary"
                                    tabIndex={1}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </Tile>
                    </Form>
                </div>
            </>
        </div>
    )
}

export default AddClients